import React from 'react';
import styled from '@emotion/styled'

// resources
import { Typography } from '@material-ui/core'
import {useTheme} from "@material-ui/core/styles";
import {makeStyles} from "@material-ui/styles";
import colorPalette from "../../../styles/theme/colorPalette";
import {css} from "@emotion/react";

const Copyright = () => {
  const theme = useTheme()
  const useStyles = makeStyles({
    root: {
      color: colorPalette.gray,
      fontSize: 12,
      fontWeight: 'fontWeightMedium'
    },
  })
  const classes = useStyles()
  
  return(
      <React.Fragment>
        <div css={wrapper}>
          <Typography className={classes.root}>
            <span>©︎2014 株式会社ファンデリー All Rights Reserved.</span>
          </Typography>
        </div>
      </React.Fragment>
  )
}

export default Copyright;

const wrapper = css`
  margin: 32px 0 24px;
  span {
    font-size: 1.2rem;
  }
`